import type { InjectionKey, Ref } from 'vue'

export const EMAIL_EDITABLE_KEY: InjectionKey<Ref<boolean>> = Symbol('emailEditable')

export function useEmailEditable() {
  const editable = inject(EMAIL_EDITABLE_KEY, ref(false))
  return { editable }
}
